import React, {
  useEffect,
  useState,
  memo,
  forwardRef,
  useImperativeHandle,
  useRef,
  useMemo
} from 'react';
import PageListView from './Components/PageList';
import RenderTab from './Components/RenderTab';
import HorizontalScroll from '@/components/HorizontalScroll';
import styles from './index.modules.less';
import { Tabs, Flex } from 'antd-mobile';
import { toJS } from 'mobx';

const MyComponent = forwardRef(({ list: itemList, hiddenContent, callback, sourceTag }, ref) => {
  const tabRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [titleOpacity, setTitleOpacity] = useState(hiddenContent ? 0 : 1);
  useImperativeHandle(ref, () => {
    return {
      getShowStatus: () => {
        return titleOpacity;
      },
      show: () => {
        setTitleOpacity(1);
      },
      hiddenAll: () => {
        setOpacity(0);
      },
      hiddenTitle: () => {
        setTitleOpacity(0);
      },
      setIdx: (idx) => {
        setActiveIndex(idx);
      }
    };
  });
  // 无数据时不渲染
  if (!itemList || itemList.length === 0) return null;
  const getTabs = () => {
    const m = (itemList || []).map((l, idx) => {
      const { title, subTitle, bizRecommendItemGridItemMallUiRespDtos: list } = l || {};
      return { title, subTitle, sub: `${idx + 1}`, list };
    });
    return m;
  };
  const tabs = useMemo(() => getTabs(), [itemList]);
  /**
   * 每一项的内容
   * @returns
   */
  const sceneMap = () => {
    if (hiddenContent) return null;
    const item = tabs[activeIndex] || {};
    return (
      <PageListView
        key={item}
        idx={activeIndex}
        type={activeIndex + 1}
        list={toJS(item.list || [])}
        sourceTag={sourceTag}
      />
    );
  };

  const tabsView = () => (
    <React.Fragment>
      <div className={styles['homeTabs-tab-bar-wrap']}>
        <HorizontalScroll
          style={{ backgroundColor: hiddenContent && titleOpacity == 1 ? '#fff' : 'transparent' }}
          activeIndex={activeIndex}
          callback={(idx) => {
            setActiveIndex(idx);
            callback && callback(idx);
          }}>
          {(tabs || []).map((item, idx) => (
            <div onClick={onclick}>
              <RenderTab
                tab={item}
                tabs={tabs}
                activeIndex={activeIndex}
                idx={idx}
                titleOpacity={titleOpacity}
              />
            </div>
          ))}
        </HorizontalScroll>
        {sceneMap()}
      </div>
    </React.Fragment>
  );

  return <React.Fragment>{tabsView()}</React.Fragment>;
});
const App = memo(MyComponent, (prevProps, nextProps) => {
  return !nextProps.hiddenContent && prevProps.list !== nextProps.list;
});

export default App;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/Tabs/index.jsx